import React from "react";
import PropTypes from "prop-types";
import ImportRequest from "../model";
import { Table, Icon, Header, Divider } from "semantic-ui-react";
import { Trans } from "react-i18next";
import {Form as FinalForm, Field, FormSpy} from "react-final-form";
import { Button } from '@weezevent/nacre';
import { SelectInput } from 'containers/contents/inputHelpers';

const validate = ({ columns }) => {
    const doubles = [];
    columns && columns.map(({ target }) => target).forEach(( target, i, targets ) => {
        if (targets.indexOf(target, i+1) !== -1 && target !== '-') {
            doubles.push(i);
            doubles.push(targets.indexOf(target, i+1));
        }
    });
    const columnsArray = Array(columns && columns.length);
    doubles.forEach((key) => columnsArray[key] = { target: <Trans i18nKey='nacre.ImportController.column-mapping.headers.duplicated'>Duplicated column</Trans> });
    return {
        columns: columnsArray
    };
};

function ColumnMapping ({
    importRequest,
    onSubmit,
    options,
    setNeedSaveDetails,
}) {

    const initialValues = React.useMemo(() => ({
        columns: importRequest.getDetails().columns && importRequest.getDetails().columns.map(({ target }) => ({ target: target || '-'})),
    }),[importRequest]);

    return (
        <FinalForm
            onSubmit={ onSubmit }
            subscription={ {
                invalid: true,
                pristine: true,
            } }
            validate={ validate }
            initialValues={ initialValues }
        >{
                ({
                    handleSubmit,
                    pristine,
                    invalid,
                    form
                }) => (
                    <form
                        onSubmit={ handleSubmit }
                    >
                        <FormSpy
                            subscription={ { pristine: true, invalid: true, values: true } }
                            onChange={ (values) => {
                                if (!values.pristine || values.invalid) {
                                    setNeedSaveDetails(true);
                                } else {
                                    setNeedSaveDetails(false);
                                }
                            } }
                        />
                        <FormSpy
                            subscription={ {submitSucceeded: true} }
                            onChange={ (values) => {
                                if(values.submitSucceeded) {
                                    setNeedSaveDetails(false);
                                }
                            } }
                        />
                        <React.Fragment>
                            <Divider horizontal>
                                <Header as="h5">
                                    <Icon
                                        className="icon-weez"
                                        name='file excel'
                                    />
                                    <Trans i18nKey='nacre.ImportController.column-mapping.title'>
                                    Headers found
                                    </Trans>
                                </Header>
                            </Divider>
                            <Table basic='very'>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>
                                            <Trans i18nKey='nacre.ImportController.column-mapping.header-found'>
                                            Headers found
                                            </Trans>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell />
                                        <Table.HeaderCell>
                                            <Trans i18nKey='nacre.ImportController.column-mapping.expected-header'>
                                            Expected headers
                                            </Trans>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {importRequest.getColumns().map((column, i) => (
                                        <Table.Row key={ i }>
                                            <Table.Cell>
                                                { column.getHeader() }
                                            </Table.Cell>
                                            <Table.Cell>
                                                <Icon name='arrow right' />
                                            </Table.Cell>
                                            <Table.Cell>
                                                <Field
                                                    name={ `columns.${i}.target` }
                                                    options={ options }
                                                >
                                                    { 
                                                        ({
                                                            input,
                                                            meta,
                                                            ...props
                                                        }) => (
                                                            <SelectInput 
                                                                meta={ meta }
                                                                input={ input }
                                                                { ...props }
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))
                                    }
                                </Table.Body>
                            </Table>
                            <Button primary onClick={ handleSubmit } disabled={ pristine || invalid }>
                                <Trans i18nKey="common.save">Save</Trans>
                            </Button>
                            <Button inverted style={ {'margin-left': '5px'} } onClick={ form.reset } disabled={ pristine }>
                                <Trans i18nKey="common.reset">reset</Trans>
                            </Button>
                        </React.Fragment>
                    </form>
                )
            }
        </FinalForm>
    );
}

ColumnMapping.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    importRequest: PropTypes.instanceOf(ImportRequest).isRequired,
    setNeedSaveDetails: PropTypes.func.isRequired
};

export default ColumnMapping;